"use client";

import AppErrorFallback from "@/components/Errors/AppErrorFallback";

export default function GlobalError({
  error,
  reset,
}: {
  error: unknown;
  reset: () => void;
}) {
  return <AppErrorFallback error={error} reset={reset} />;
}

